// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.weavecolor-table-container {
  --table-bg-color: #fff;
  --table-border-color: var(--cui-border-color, #d8dbe0);
  --table-text-color: var(--cui-body-color, #4f5d73);
}
html[data-coreui-theme=dark] .weavecolor-table-container {
  --table-bg-color: var(--cui-dark-bg-subtle, #1e1e2f);
  --table-border-color: var(--cui-dark-border-subtle, #333);
  --table-text-color: var(--cui-body-color, #fff);
}
.weavecolor-table-container .table {
  border-color: var(--table-border-color) !important;
  width: 100%;
  color: var(--table-text-color);
}
.weavecolor-table-container .table thead th {
  font-weight: 600;
  border-color: var(--table-border-color) !important;
}
.weavecolor-table-container .table tbody tr:hover {
  background-color: inherit;
  border-color: var(--table-border-color) !important;
  color: var(--table-text-color) !important;
}
.weavecolor-table-container .table tbody tr:hover td {
  color: var(--table-text-color) !important;
}
.weavecolor-table-container .table tbody tr:hover th {
  color: var(--table-text-color) !important;
}
.weavecolor-table-container .table td {
  border-color: var(--table-border-color) !important;
}
.weavecolor-table-container .card {
  background-color: var(--table-bg-color);
  border-color: var(--table-border-color) !important;
}
.weavecolor-table-container .card-body {
  background-color: var(--table-bg-color);
  color: var(--table-text-color);
}
.weavecolor-table-container .pagination {
  margin-top: 1rem;
}
.weavecolor-table-container .cursor-pointer {
  cursor: pointer;
}
.weavecolor-table-container .cursor-pointer:hover {
  opacity: 0.85;
}`, "",{"version":3,"sources":["webpack://./src/components/WeaveColorTable/WeaveColorTable.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,sDAAA;EACA,kDAAA;AACF;AACE;EACE,oDAAA;EACA,yDAAA;EACA,+CAAA;AACJ;AAEE;EACE,kDAAA;EACA,WAAA;EACA,8BAAA;AAAJ;AAGE;EACE,gBAAA;EACA,kDAAA;AADJ;AAIE;EACE,yBAAA;EACA,kDAAA;EACA,yCAAA;AAFJ;AAII;EACE,yCAAA;AAFN;AAKI;EACE,yCAAA;AAHN;AAOE;EACE,kDAAA;AALJ;AAQE;EACE,uCAAA;EACA,kDAAA;AANJ;AASE;EACE,uCAAA;EACA,8BAAA;AAPJ;AAUE;EACE,gBAAA;AARJ;AAWE;EACE,eAAA;AATJ;AAUI;EACE,aAAA;AARN","sourcesContent":[".weavecolor-table-container {\n  --table-bg-color: #fff;\n  --table-border-color: var(--cui-border-color, #d8dbe0);\n  --table-text-color: var(--cui-body-color, #4f5d73);\n\n  html[data-coreui-theme=\"dark\"] & {\n    --table-bg-color: var(--cui-dark-bg-subtle, #1e1e2f);\n    --table-border-color: var(--cui-dark-border-subtle, #333);\n    --table-text-color: var(--cui-body-color, #fff);\n  }\n\n  .table {\n    border-color: var(--table-border-color) !important;\n    width: 100%;\n    color: var(--table-text-color);\n  }\n\n  .table thead th {\n    font-weight: 600;\n    border-color: var(--table-border-color) !important;\n  }\n\n  .table tbody tr:hover {\n    background-color: inherit;\n    border-color: var(--table-border-color) !important;\n    color: var(--table-text-color) !important;\n    \n    td {\n      color: var(--table-text-color) !important;\n    }\n    \n    th {\n      color: var(--table-text-color) !important;\n    }\n  }\n\n  .table td {\n    border-color: var(--table-border-color) !important;\n  }\n\n  .card {\n    background-color: var(--table-bg-color);\n    border-color: var(--table-border-color) !important;\n  }\n\n  .card-body {\n    background-color: var(--table-bg-color);\n    color: var(--table-text-color);\n  }\n\n  .pagination {\n    margin-top: 1rem;\n  }\n\n  .cursor-pointer {\n    cursor: pointer;\n    &:hover {\n      opacity: 0.85;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
